import { Customer } from '@leid/api-customers'

export const collectCustomerDataWithSegment = (customer: Customer | undefined): void => {
  if (customer && window.analytics) {
    window.analytics.identify(customer.id, {
      name: customer.fullName,
      email: customer.email,
    })
  }
}
